export const LIFE_DISABILITY = 'lifeDisability'
export const DISABILITY = 'disability'
export const LIFE = 'life'
export const CI = 'ci'

export const HEALTH_INFORMATION_SEGMENTS = [LIFE_DISABILITY, DISABILITY, LIFE, CI]
